const UUID_SEGMENT = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
const PUBLIC_ID_SEGMENT = /^\d{9}$/;

/**
 * A path as it goes into a Sentry tag or breadcrumb: no query string, no host, and every id
 * segment replaced so one issue groups all orders, not one issue per order. Pure.
 */
export function normalisePath(url: string): string {
  if (!url) return '';
  let path = url;
  if (/^https?:\/\//i.test(path)) {
    const slash = path.indexOf('/', path.indexOf('//') + 2);
    path = slash === -1 ? '/' : path.slice(slash);
  }
  const queryAt = path.search(/[?#]/);
  if (queryAt !== -1) path = path.slice(0, queryAt);
  return path
    .split('/')
    .map((segment) =>
      UUID_SEGMENT.test(segment) ? ':id' : PUBLIC_ID_SEGMENT.test(segment) ? ':publicId' : segment,
    )
    .join('/');
}
